import Reveal from "./Reveal";
import ChapterHeader from "./ChapterHeader";

export default function Manifesto({ t }) {
  const c = t.chapter01;
  return (
    <section id="services" className="pb-20 md:pb-28">
      <ChapterHeader
        num={c.num}
        overline={c.overline}
        title={c.title}
      />
      <div className="container-x mt-12 md:mt-16 grid grid-cols-12 gap-8 md:gap-12">
        <div className="col-span-12 md:col-span-5">
          <Reveal delay={0.1}>
            <p className="font-serif-italic text-2xl md:text-3xl leading-snug text-[var(--text)] max-w-md">
              {c.body}
            </p>
          </Reveal>
        </div>
        <div className="col-span-12 md:col-span-7 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {c.points.map((p, i) => (
            <Reveal key={i} delay={0.15 + i * 0.08}>
              <div
                className="card-hover h-full border border-[var(--border)] rounded-2xl p-6 md:p-7 bg-[var(--surface)]"
                data-testid={`manifesto-point-${i}`}
              >
                <div className="text-[var(--accent)] text-3xl font-display font-black mb-6">
                  {p.n}
                </div>
                <div className="font-display font-bold text-lg md:text-xl uppercase tracking-tight text-[var(--text)]">
                  {p.t}
                </div>
                <p className="mt-3 text-sm text-[var(--text-muted)] leading-relaxed">
                  {p.d}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
